define("logger", [
    "https://xf-dc.oss-cn-hangzhou.aliyuncs.com/cloudladder-v1.4.0.js",
], function () {
    var Logger = {
        init: function () {
            var logConf = window.config.config.LOGGER;
            logConf = logConf.split(",");

            var loggerFactory = new window.LoggerFactory(
                logConf[0],
                logConf[1],
                logConf[2]
            );
            loggerFactory.setC("huanjing").setAppv("1.0");
            window.loggerFactory = loggerFactory;
        },
        baseReport: function (action, config, uid) {
            config = config || [];
            if (!window.loggerFactory) {
                Logger.init();
            }
            // eslint-disable-next-line no-unused-expressions
            uid && window.loggerFactory.setUid(uid);
            var logger = window.loggerFactory.getLogger("event");
            logger.setAction(action);
            var innerConfig = config;

            innerConfig.forEach(function (item) {
                var key = item.key;
                var value = item.value;
                var type = item.type;
                if (type === "string") {
                    logger.putString(key, value);
                } else if (type === "number") {
                    logger.putNumber(key, value);
                }
            });

            logger.send();
        },
        loginReport: function (action, data) {
            var logData = [
                {
                    key: "evkappid",
                    value: +window.config.config.APPID,
                    type: "number",
                },
                {
                    key: "evkfirstcreate",
                    value: data.evkFirstCreate ? 1 : 0,
                    type: "number",
                },
                {
                    key: "firstcreate",
                    value: data.firstCreate ? 1 : 0,
                    type: "number",
                },
            ];
            Logger.baseReport(action, logData, data.gramakerId);
        },
    };

    return Logger;
});
